<template>
    <div class="grid grid-cols-1 gap-1">
        
        <InputText
            v-model:inputValue="form.fullName"
            :errorInfo="errorInfo[0]"
            :isShowError="true"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.register.fullName"
            :isTextOnly="true"
            @update:inputValue="onFormUpdate()">
        </InputText>
        <InputNationalId
            v-model:inputValue="form.nationalId"
            :errorInfo="errorInfo[1]"
            :isShowError="true"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.profile.idCard" />
        <InputContactNumber
            v-model:inputValue="form.contactNumber"
            delimeter="-"
            :maxLength="12"
            :minLength="12"
            :errorInfo="errorInfo[2]"
            :isShowError="true"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.register.contactNumber"
            @update:inputValue="onFormUpdate()" />
        <DatePickerDropdown
            v-model:inputValue="form.birthDay"
            :errorInfo="errorInfo[3]"
            :isShowError="true"
            :isSubmitted="isSubmitted"
            :inputLbl="lbl.profile.birthdate"
            @update:inputValue="onFormUpdate()"
         />
    </div>
</template>
<script>
import { DropdownListValue, FormHelper } from '@/helper/FormHelper';

//component
import InputText from '@/components/Input/label/InputText.vue'
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import InputNationalId from '@/components/Input/label/InputNationalId.vue';
import DatePickerDropdown from '@/components/Input/label/DatePickerDropdown.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin'
//service
import { RegisterModel } from '../../model/RegisterModel';
import { AddressModel } from '@/core/Address/model/AddressModel';

import Utility from '@/helper/Utility';
import { ref, watch } from 'vue';

export default {
    name: 'FormRegister',
    mixins: [LocaleMixin],
    components: {
        InputText,
        InputContactNumber,
        InputNationalId,
        DatePickerDropdown,
        // InputRadioGroup
    },
    props:{
        modelValue: { type: Boolean}
    },
    emits: ["update:modelValue"],
    data: function () {
        return {
            isSubmitted: false,
            address: new AddressModel(),
            // errorInfo: FormHelper.genErrorInfo(5),
            prefixNameItems: []
        };
    },
    computed: {

    },
    created: function () {
        const keyValuePrefixNameBuilder = new DropdownListValue()
        keyValuePrefixNameBuilder.add("นาย", "นาย")
        keyValuePrefixNameBuilder.add("นาง", "นาง")
        keyValuePrefixNameBuilder.add("นางสาว", "นางสาว")
        this.prefixNameItems = keyValuePrefixNameBuilder.getList()
    },
    setup: function(props, ctx){
        const questionarieId = 2709
        const errorInfo = ref(FormHelper.genErrorInfo(4))
        const form = ref(new RegisterModel())
        form.value.setQuestionarieId(questionarieId)
        form.value.setLineDataFromCookie()

        const formValid = ref(false)

        watch(errorInfo, ()=>{
            let valid = FormHelper.validate(errorInfo.value);
            ctx.emit("update:modelValue", valid)
        }, {
            deep: true
        })

        return {
            form,
            formValid,
            errorInfo
        }
    },
    methods: {
        validate: function () {
            this.isSubmitted = true;
            let valid = FormHelper.validate(this.errorInfo) && !Utility.isEmptyStr(this.form.prefix);
            return valid;
        },
        getValue: function () {
            return this.form;
        },

        onFormUpdate: function () {
            this.saveCacheForm();
        },
        saveCacheForm: function () {
            this.form.saveCache()
        },
    },
}
</script>

